/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IMedicine } from 'app/shared/model/medicine.model';
import { IPrescription } from 'app/shared/model/prescription.model';
import { IPharmacy } from 'app/shared/model/pharmacy.model';
import { PatientType } from 'app/shared/model/enumerations/patient-type.model';

export interface IMedicationDetails {
  id?: string;
  repetition?: string;
  tmEnd?: number | null;
  currentSupply?: string;
  refillSize?: string;
  timestampentry?: number;
  active?: boolean;
  lastupdated?: number;
  cursor?: number;
  microSec?: number;
  prescribedCount?: number;
  indication?: string;
  daysFrequency?: string | null;
  endDate?: number;
  dose?: string | null;
  route?: string | null;
  stopped?: boolean | null;
  stoppedBy?: string | null;
  patientType?: keyof typeof PatientType | null;
  exposed?: boolean | null;
  medicineName?: string | null;
  doseInstructions?: string | null;
  tmType?: string;
  glucoUser?: IGlucoUser;
  medicine?: IMedicine;
  prescription?: IPrescription | null;
  servedBy?: IPharmacy | null;
}

export const defaultValue: Readonly<IMedicationDetails> = {
  active: false,
  stopped: false,
  exposed: false,
};
